export const allowedIntegrations = [
  'salesforce',
  'hubspot',
  'marketo',
  'eloqua',
  'pardot'
]


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/IntegrationEventLog/constants.js